import "./App.css";
import { Routes } from "react-router-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Dashboard from "./Screens/Dashboard";
import "../src/assets/css/Style.css";
import UserWallet from "./Screens/UserWallet";
import Network from "./Screens/Network";
import ResetPassword from "./Screens/ResetPassword";
import Exchange from "./Screens/Exchange";
import SupportTicket from "./Screens/SupportTicket";
import Profile from "./Screens/Profile";
import Settings from "./Screens/Settings";
import Subscription from "./Screens/Subscription";
import AddSettings from "./Screens/AddSettings";
import Pairs from "./Screens/Pairs";
import Exchanges from "./Screens/Exchanges";
import Users from "./Screens/Users";
import LoginUsers from "./Screens/LoginUsers";
import UserSubscribed from "./Screens/UserSubscribed";

import MarketOpportunities from "./Screens/MarketOpportunities";
import UserSettings from "./Screens/UserSettings";
import SiteSettings from "./Screens/SiteSettings";
import TradeHistory from "./Screens/TradeHistory";
import ScheduleHistory from "./Screens/ScheduleHistory";
import Subadmin from "./Screens/Subadmin";
import AddSubscription from "./Screens/AddSubscription";
import EditSubscription from "./Screens/EditSubscription";

import ForgotPassword from "./Screens/ForgotPassword";
import ResetNewPassword from "./Screens/ResetNewPassword";
import OTPVerification from "./Screens/OTPVerification";

import LoginPage from "./Screens/LoginPage";
import Tokens from "./Screens/Tokens";

// import { ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { Provider, useDispatch } from "react-redux";
import { store } from "./Redux/Store";
import ConditionRoute from "./Components/ConditionRoute";
import NotFound from "./Components/NotFound";
import Schedules from "./Screens/Schedules";
import Cms from "./Screens/Cms";
import Faq from "./Screens/Faq";
import EmailTemplate from "./Screens/EmailTemplate";
import Newsletter from "./Screens/NewsLetter";
import TrendingPair from "./Screens/TrendingPair";
import Rankingpair from "./Screens/Rankingpair";
import SuggestPair from "./Screens/SuggestPair";
import AddPairsPage from "./Screens/addPairsPage";


function App() {
  let records = store.getState();
  let restriction = records.isRun.restriction;
  const dispatch = useDispatch();

  dispatch({
    type: "SET_ADMINWALLET",
    payload: localStorage.getItem("adminWalletAddress"),
  });

  return (
    <>
      <BrowserRouter>
        <div>
          <Toaster />
        </div>
        <Switch>
          <ConditionRoute
            exact
            path="/"
            component={LoginPage}
            type={"public"}
          ></ConditionRoute>

          <ConditionRoute
            exact
            path="/forgotPassword"
            component={ForgotPassword}
            type={"public"}
          ></ConditionRoute>

          <ConditionRoute
            exact
            path="/resetNewPassword"
            component={ResetNewPassword}
            type={"public"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/otpVerification"
            component={OTPVerification}
            type={"public"}
          ></ConditionRoute>

          <ConditionRoute
            exact
            path="/dashboard"
            component={Dashboard}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/pairsDetsils"
            component={AddPairsPage}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/userWallet"
            component={UserWallet}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/supportTicket"
            component={SupportTicket}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/network"
            component={Network}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/schedules"
            component={Schedules}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/exchange"
            component={Exchange}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/profile"
            component={Profile}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/settings"
            component={Settings}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/userSettings"
            component={UserSettings}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/siteSettings"
            component={SiteSettings}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/subscription"
            component={Subscription}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/resetPassword"
            component={ResetPassword}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/addSettings"
            component={AddSettings}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/tradeHistory"
            component={TradeHistory}
            type={"private"}
          ></ConditionRoute>
          {/* <ConditionRoute
            exact
            path="/transaction-history"
            component={ScheduleHistory}
            type={"private"}
          ></ConditionRoute> */}
          <ConditionRoute
            exact
            path="/subAdmin"
            component={Subadmin}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/pairs"
            component={Pairs}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/exchanges"
            component={Exchanges}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/users"
            component={Users}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/login-users"
            component={LoginUsers}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/suggest-pair"
            component={SuggestPair}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/addSubscription"
            component={AddSubscription}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/tokens"
            component={Tokens}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/trending-pair"
            component={TrendingPair}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/suggest-pair"
            component={SuggestPair}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/ranking-pair"
            component={Rankingpair}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/editsubscription"
            component={EditSubscription}
            type={"private"}
          ></ConditionRoute>

          <ConditionRoute
            exact
            path="/cms"
            component={Cms}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/faq"
            component={Faq}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/email-template"
            component={EmailTemplate}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/newsletter"
            component={Newsletter}
            type={"private"}
          ></ConditionRoute>
          <ConditionRoute
            exact
            path="/usersubscribed"
            component={UserSubscribed}
            type={"private"}
          ></ConditionRoute>
        </Switch>

      </BrowserRouter>
    </>
  );
}

export default App;
